export const showsRoutes = {
    main: {
        route: '/shows',
        get: () => `/shows`,
    },
    notFound: {
        route: '/shows/not-found',
        get: () => `/shows/not-found`,
    },
    search: {
        main: {
            route: '/shows/search',
            get: (text) => (text ? `/shows/search?q=${text}` : `/shows/search`),
        },
    },
    getStarted: {
        main: {
            route: '/shows/get-started',
            get: () => `/shows/get-started`,
        },
        createProfile: {
            route: '/shows/get-started/create-profile',
            get: () => `/shows/get-started/create-profile`,
        },
        success: {
            route: '/shows/get-started/success',
            get: () => `/shows/get-started/success`,
        },
    },
    whoIsWatching: {
        main: {
            route: '/shows/who-is-watching',
            get: (next) => (next ? `/shows/who-is-watching?next=${next}` : `/shows/who-is-watching`),
        },
    },
    manageProfiles: {
        main: {
            route: '/shows/manage-profiles',
            get: () => `/shows/manage-profiles`,
        },
        new: {
            route: '/shows/manage-profiles/new/:uuid',
            get: (uuid) => `/shows/manage-profiles/new/${uuid}`,
        },
        edit: {
            route: '/shows/manage-profiles/edit/:uuid',
            get: (uuid) => `/shows/manage-profiles/edit/${uuid}`,
        },
    },
    movies: {
        main: {
            route: '/shows/movies',
            get: () => `/shows/movies`,
        },
        movie: {
            route: '/shows/movie/:uuid',
            get: (uuid, play) => {
                return play ? `/shows/movie/${uuid}?play=${play}` : `/shows/movie/${uuid}`;
            },
        },
        purchase: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/purchase/app-shows/movies/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/purchase/app-shows/movies/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
        rent: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/rent/app-shows/movies/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/rent/app-shows/movies/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
    },
    tvs: {
        main: {
            route: '/shows/tvs',
            get: () => `/shows/tvs`,
        },
        tv: {
            route: '/shows/tv/:uuid',
            get: (uuid) => {
                return `/shows/tv/${uuid}`;
            },
        },
        purchase: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/purchase/app-shows/tvs/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/purchase/app-shows/tvs/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
        rent: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/rent/app-shows/tvs/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/rent/app-shows/tvs/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
    },
    seasons: {
        purchase: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/purchase/app-shows/seasons/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/purchase/app-shows/seasons/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
        rent: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/rent/app-shows/seasons/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/rent/app-shows/seasons/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
    },
    episodes: {
        purchase: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/purchase/app-shows/episode/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/purchase/app-shows/episode/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
        rent: {
            api: {
                stripe: {
                    createCheckoutSession: {
                        route: '/api/rent/app-shows/episode/stripe/create-checkout-session/:uuid',
                        get: (uuid) => `/api/rent/app-shows/episode/stripe/create-checkout-session/${uuid}`,
                    },
                },
            },
        },
    },
    series: {
        series: {
            route: '/shows/series/:slug',
            get: (slug) => `/shows/series/${slug}`,
        },
    },
    saved: {
        main: {
            route: '/shows/saved',
            get: () => '/shows/saved',
        },
    },
    player: {
        show: {
            route: '/shows/player/:uuid',
            get: (uuid, fresh = false) => {
                return `/shows/player/${uuid}?fresh=${fresh ? 'yes' : 'no'}`;
            },
        },
    },
};
//# sourceMappingURL=shows.js.map